import {ShapeCommand} from '../commands.template';
import * as _ from 'lodash';

export class ActivityAddStoryCommand extends ShapeCommand {
  services: any;
  firstAction: boolean;
  mxKey;
  constructor(data) {
    super(data);
    this.mxKey = 0;
    this.firstAction = true;
  }

  public execute() {
    const mxKey = this.getMxKey(this.object.itemMxKey);
    const param = this.getStoryInterface(this.object.items, mxKey, false);

    this.mxKey = _.map(param, item => +item.mxKey);
    const action = {createStoryAttachment: param};

    return this.services.diagramUpdateSvc.update(action, true, true).then(result => {
      const storyAttachmentObject = this.getStoryInterface(this.object.items, mxKey, true);

      this.services.jsonHandlerSvc.update({createStoryAttachment: storyAttachmentObject});
      this.redrawActivity(this.object.itemMxKey);

      return result;
    });
  }

  public reverse() {
    const action = {
      deleteStoryAttachment: {
        itemMxKey: this.object.itemMxKey, // activity mxKek
        mxKey: this.mxKey // attachments mxKey
      }
    };

    return this.services.diagramUpdateSvc.update(action, true, true).then(result => {
      this.services.jsonHandlerSvc.update(action);
      this.redrawActivity(this.object.itemMxKey);

      return result;
    });
  }

  private getMxKey(itemMxKey) {
    const diagramJson = this.services.jsonHandlerSvc.get();

    const activity = _.find(diagramJson.activities, act => +act.mxKey === +itemMxKey);

    if (!activity.storyAttachments) {
      activity.storyAttachments = [];
    }

    let mxKey = 0;

    activity.storyAttachments.forEach(function (attachment) {
      if (attachment.mxKey > mxKey) {
        mxKey = attachment.mxKey;
      }
    });

    return mxKey + 1;
  }

  private getStoryInterface(data, mxKey, populateStory) {
    let key = Number(mxKey);

    return _.map(data, el => {
      return {
        mxKey: key++,
        itemMxKey: el.itemMxKey,
        type: 'story',
        storyId: el.storyId,
        story: populateStory
          ? {
              id: el.id,
              status: el.status,
              issueUrl: el.issueUrl
            }
          : el.id,
        title: el.summary.substring(60, 0),
        description: '',
        groups: el.groups
      };
    });
  }

  private redrawActivity(mxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(mxKey))
      .comp.instance.setupFromJson();
  }
}
